import React, { useEffect } from 'react';
import Card from '~/components/Card';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import DataTable from 'react-data-table-component';
import Spinner from 'react-bootstrap/Spinner';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import { deleteBiomeItemApi, fetchBiomeApi } from './biomeSlice';

const customStyles = {
    table: {
        style: {
            border: '1px solid #F5F7FA',
        },
    },
    headCells: {
        style: {
            fontWeight: 'bold',
            padding: '15px',
        },
    },
};

const columns = [
    {
        name: '#',
        selector: (row) => row.id,
    },
    {
        name: 'Name',
        selector: (row) => row.biome_name,
        sortable: true,
    },
    {
        name: 'Action',
        selector: (row) => row.biome_name,
        cell: (row) => (
            <EditDeleteBtn
                row={row}
                thunkFunc={deleteBiomeItemApi}
            />
        ),
    },
];

function Biome() {
    const { biomeRows } = useSelector((state) => state.cardSaga.biome);
    const { isLoading } = useSelector((state) => state.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (biomeRows.length > 0) return;
        dispatch(fetchBiomeApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-6 offset-sm-3">
                <DataTable
                    columns={columns}
                    data={biomeRows}
                    striped
                    pagination
                    paginationPerPage="10"
                    persistTableHead
                    progressPending={isLoading} //spinning icon will trigger when isLoading = 1
                    noDataComponent={<h3 className="m-3">No data...</h3>}
                    progressComponent={
                        <Spinner
                            animation="border"
                            role="status"
                        >
                            <span className="visually-hidden"></span>
                        </Spinner>
                    }
                    customStyles={customStyles}
                />
            </div>
        </Card>
    );
}

export default Biome;
